import { Component, Inject, type OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
import { concatMap, EMPTY, forkJoin, map, type Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UserProfile } from '../../shared/models/user-profile';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountDetail } from '../../shared/models/account-detail';
import { type ServiceAddress } from '../../shared/models/service-address';
import { MatSort, type Sort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { LiveAnnouncer } from '@angular/cdk/a11y';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PlanService } from '../../shared/services/plan.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
import { PerThermPipe } from '../../shared/pipes/per-therm.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
import { isWithinInterval, subDays } from 'date-fns';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-service-agreements',
  imports: [
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NotificationComponent,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    PageHeaderComponent,
  ],
  templateUrl: './service-agreements.component.html',
  styleUrl: './service-agreements.component.scss',
  providers: [PerThermPipe],
})
export class ServiceAgreementsComponent implements OnInit {
  pageLabels: any = {};
  pageReady = false;
  formErrorMessage?: string = '';
  isBrowser = false;
  userProfile?: UserProfile;
  accountDetail?: AccountDetail;
  serviceAgreements: ServiceAddress[] = [];
  mobileServiceAgreements: ServiceAddress[] = [];
  dataSource: any = [];
  displayedColumns: string[] = [
    'address',
    'status',
    'plantype',
    'planprice',
    'turnondate',
    'turnoffdate',
    'enddate',
    'transfer',
  ];

  notification = '';
  pageName = 'Service Agreement';
  pageSize = 15;
  length = 0;
  pageEvent: PageEvent | undefined;
  pageIndex = 0;
  isMobile: boolean = false;
  breakpoint: BreakpointState | undefined;
  mobilePanelIndex: number | undefined;
  showFirstLastButtons: boolean = true;
  headerData = new PageHeader();
  oppTag: string = '';

  @ViewChild(MatPaginator, { static: false }) set paginator(pag: MatPaginator) {
    if (pag) {
      this.dataSource.paginator = pag;
      this.pageIndex = this.dataSource._paginator._pageIndex;
    }
  }

  get paginator(): any {
    return this.dataSource.paginator;
  }

  @ViewChild(MatSort, { static: false }) set vcsort(v: MatSort) {
    if (v) {
      this.dataSource.sort = v;
    }
  }

  get vcsort(): any {
    return this.dataSource.sort;
  }

  constructor(
    private readonly _liveAnnouncer: LiveAnnouncer,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly utils: UtilService,
    private readonly account: AccountService,
    private readonly storage: StorageService,
    private readonly notifi: NotificationsService,
    private readonly plan: PlanService,
    private readonly router: Router,
    private readonly perThermPipe: PerThermPipe,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    this.plan.setPerThermPipe(this.perThermPipe);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.oppTag = this.storage.getSession(StorageEnum.GlobalVars).oppTag;
    }
    this.cms
      .getContent('oas-service-agreements', 'OAS Service Agreements')
      .pipe(
        concatMap((data) => {
          this.pageLabels = data;
          this.headerData.Message = this.pageLabels.header;
          this.seoS.setSeoTags(data.seo);
          if (this.isBrowser) {
            const numAgreements = this.userProfile?.Accounts[0]?.NumAgreements ?? 0;
            const totalPages = Math.ceil(numAgreements / this.pageLabels.agreementsPerRequest);
            const acctNumber = this.userProfile?.Accounts[0]?.AccountNumber ?? '';
            const userName = this.userProfile?.UserName ?? '';
            const pageList = Array.from({ length: totalPages }, (_, i) => i + 1);
            const serviceArr: Array<Observable<any>> = [];

            // create array of observables to forkjoin based on number of pages needed to retrieve all service agreements
            pageList.forEach((page) => {
              const startIndex = page * this.pageLabels.agreementsPerRequest + 1 - this.pageLabels.agreementsPerRequest;
              const endIndex = page * this.pageLabels.agreementsPerRequest;
              serviceArr.push(this.account.getServiceAgreements(acctNumber, userName, startIndex, endIndex));
            });

            return forkJoin(serviceArr).pipe(
              map((results) => {
                // combine results from each observable into single array
                const allServiceAgreements: ServiceAddress[] = [];
                results.forEach((res) => {
                  allServiceAgreements.push(...res);
                });
                return allServiceAgreements;
              }),
            );
          } else {
            return EMPTY;
          }
        }),
        concatMap((data: any[]) => {
          if (this.isBrowser) {
            const sortedData = data.slice()?.sort((a, b) => {
              return this.compareStatus(true, a?.SaStatusFlag, b?.SaStatusFlag);
            });
            this.dataSource = new MatTableDataSource(sortedData);
            this.serviceAgreements = sortedData;
            this.length = sortedData.length;
            this.updateMobileData(this.dataSource.data);
            this.populateRateDetails();
            this.checkForNotificationMessage();
            return this.checkScreenSize();
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe((data) => {
        this.breakpoint = data.breakpoints;
        if (data.matches) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
          this.mobilePanelIndex = -1;
        }
        this.checkForNotificationMessage();
        this.pageReady = true;
        this.utils.hideSpinner();
      });
  }

  checkForNotificationMessage(): void {
    const saUpForRenewal = this.serviceAgreements?.find((sa) => sa.SARenewalIndicator === 'Y');
    if (saUpForRenewal && this.accountDetail?.CustomerClass !== 'LRGCOM') {
      this.notifi.addNotification(
        this.pageLabels.saUpForRenewalNotificationMessage,
        NotificationType.StatementPreNotification,
        this.pageName,
      );
    }

    if (!saUpForRenewal && this.accountDetail?.CustomerClass !== 'LRGCOM') {
      this.notifi.addNotification(
        this.pageLabels.startServiceNotificationMessage,
        NotificationType.StatementPreNotification,
        this.pageName,
        {
          ctaLabel: this.pageLabels.startServiceLink.value.name,
          ctaLink: this.pageLabels.startServiceLink.value.data.url,
          ctaAriaLabel: this.pageLabels.startServiceLink.value.data.ariaLabel,
        },
      );
    }

    if (this.accountDetail?.CustomerClass === 'LRGCOM') {
      this.notifi.addNotification(
        this.pageLabels.largeComPreNotificationMessage,
        NotificationType.Prenotification,
        this.pageName,
      );
    }
    if (this.notification !== '') {
      this.notifi.addNotification(this.notification, NotificationType.Postnotification, this.pageName);
    }
  }

  populateRateDetails(): void {
    this.serviceAgreements?.forEach((sa) => {
      const planData = this.getPlanData(sa);
      sa.BillingRateDescription = planData.billRate;
      sa.SaRateScheduleCode = planData.planType.toUpperCase().includes('ONEPRICE')
        ? planData.planType + this.oppTag
        : planData.planType;
    });
  }

  getPlanData(sa: ServiceAddress): any {
    if (sa.BillingRate?.toUpperCase().includes('VARIABLE')) {
      sa.BillingRateValue = sa.BillingRate;
      return this.plan.getAllPlanData(
        sa.SaRateScheduleCode,
        this.accountDetail?.CustomerClass,
        sa.BillingRateValue,
        sa.SaRateScheduleCode,
        sa.SaStatusFlag,
      );
    } else {
      return this.plan.getAllPlanData(
        sa.SaRateScheduleCode,
        this.accountDetail?.CustomerClass,
        sa.BillingRate,
        sa.SaRateScheduleCode,
      );
    }
  }

  goToRateChange(sa: ServiceAddress): any {
    this.storage.setSession(StorageEnum.SelectedSA, sa);
    void this.router.navigateByUrl(this.pageLabels.rateChangeLink.value.data.url);
  }

  goToRateRenewal(sa: ServiceAddress): any {
    this.storage.setSession(StorageEnum.SelectedSA, sa);
    void this.router.navigateByUrl(this.pageLabels.rateRenewalLink.value.data.url);
  }

  goToReconnect(sa: ServiceAddress): any {
    this.storage.setSession(StorageEnum.SelectedSA, sa);
    void this.router.navigateByUrl(this.pageLabels.reconnectServiceLink.value.data.url);
  }

  goToTransfer(sa: ServiceAddress): any {
    this.storage.setSession(StorageEnum.SelectedSA, sa);
    void this.router.navigateByUrl(this.pageLabels.moveServiceLink.value.data.url);
  }

  goToStop(sa: ServiceAddress): any {
    this.storage.setSession(StorageEnum.SelectedSA, sa);
    void this.router.navigateByUrl(this.pageLabels.stopServiceLink.value.data.url);
  }

  elegibleForReconnect(sa: ServiceAddress): any {
    const inInterval = isWithinInterval(new Date(sa.SaEndDate ?? ''), {
      start: subDays(new Date(), 90),
      end: new Date(),
    });

    return inInterval;
  }

  sortData(sort: Sort): void {
    const data = this.serviceAgreements?.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource = new MatTableDataSource(data);
      this.updateMobileData(this.dataSource.data);
      return;
    }
    this.dataSource = new MatTableDataSource(
      data?.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'address':
            return this.compare(isAsc, a?.Address1, b?.Address1);
          case 'status':
            return this.compareStatus(isAsc, a?.SaStatusFlag, b?.SaStatusFlag);
          case 'plantype':
            return this.compare(isAsc, a?.SaRateScheduleCode, b?.SaRateScheduleCode);
          case 'planprice':
            return this.compare(isAsc, a.BillingRateDescription, b.BillingRateDescription);
          case 'turnondate':
            return this.compare(isAsc, a.SaStartDate, b.SaStartDate);
          case 'turnoffdate':
            return this.compare(isAsc, a.SaEndDate, b.SaEndDate);
          case 'enddate':
            return this.compare(isAsc, a.BillingRateExpirationDate, b.BillingRateExpirationDate);
          default:
            return 0;
        }
      }),
    );
    this.updateMobileData(this.dataSource.data);
  }

  mobileSortData(sortType: string): void {
    const data = this.dataSource.data.slice();
    if (sortType === 'clear') {
      this.updateMobileData(data);
    } else {
      this.mobileServiceAgreements = data?.sort((a: any, b: any) => {
        let filterType;
        switch (sortType) {
          case 'pending start':
            filterType = 'pending start';
            if (
              (a.SaStatusDescription?.toLowerCase() === filterType || a.SaStatusDescription === '10') &&
              !(b.SaStatusDescription?.toLowerCase() === filterType || b.SaStatusDescription === '10')
            ) {
              return -1;
            } else {
              return 1;
            }
          case 'active':
            filterType = 'active';
            if (
              (a.SaStatusDescription?.toLowerCase() === filterType ||
                a.SaStatusDescription === '20' ||
                a.SaStatusDescription === '50') &&
              !(
                b.SaStatusDescription?.toLowerCase() === filterType ||
                b.SaStatusDescription === '20' ||
                b.SaStatusDescription === '50'
              )
            ) {
              return -1;
            } else {
              return 1;
            }
          case 'stopped':
            filterType = 'stopped';
            if (
              (a.SaStatusDescription?.toLowerCase() === filterType || a.SaStatusDescription === '40') &&
              !(b.SaStatusDescription?.toLowerCase() === filterType || b.SaStatusDescription === '40')
            ) {
              return -1;
            } else {
              return 1;
            }
          case 'closed':
            filterType = 'closed';
            if (
              (a.SaStatusDescription?.toLowerCase() === filterType ||
                a.SaStatusDescription === '60' ||
                a.SaStatusDescription === '70') &&
              !(
                b.SaStatusDescription?.toLowerCase() === filterType ||
                b.SaStatusDescription === '60' ||
                b.SaStatusDescription === '70'
              )
            ) {
              return -1;
            } else {
              return 1;
            }
          default:
            return 0;
        }
      });
      this.updateMobileData(this.mobileServiceAgreements);
    }
  }

  setOpenMobilePanelIndex(index: number): void {
    if (index === this.mobilePanelIndex) {
      this.mobilePanelIndex = -1;
    } else {
      this.mobilePanelIndex = index;
    }
  }

  checkScreenSize(): Observable<any> {
    return this.breakpointObserver.observe(['(max-width: 992px)']);
  }

  handlePageEvent(e: PageEvent): void {
    this.pageEvent = e;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.updateMobileData(this.dataSource.data);
  }

  updateMobileData(data: any): void {
    if (this.pageIndex !== 0) {
      this.mobileServiceAgreements = data?.slice(this.pageIndex * this.pageSize, (this.pageIndex + 1) * this.pageSize);
    } else {
      this.mobileServiceAgreements = data?.slice(this.pageIndex, this.pageSize);
    }
  }

  showRenewalRateChange(saStatus: string, billingRateDescription: string): any {
    return (
      (saStatus === '20' || saStatus === '50') &&
      billingRateDescription.toLowerCase() !== 'market based' &&
      this.accountDetail?.LandLordAlertIndicator !== 'Y'
    );
  }

  compare(isAsc: boolean, a?: number | string, b?: number | string): number {
    if (a && b) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    return 0;
  }

  compareStatus(isAsc: boolean, a?: number | string, b?: number | string): number {
    if (a && b) {
      return (this.compareStatusHelper(a) < this.compareStatusHelper(b) ? -1 : 1) * (isAsc ? 1 : -1);
    }
    return 0;
  }

  compareStatusHelper(status: string | number): number {
    switch (status) {
      case '10':
        return 1;
      case '20':
        return 2;
      case '50':
        return 3;
      case '40':
        return 4;
      case '60':
      case '70':
        return 5;
      default:
        return 6;
    }
  }
}
